module.exports = __webpack_public_path__ + "static/media/person3.4a7a9298.png";